import { ProductImageService } from '$js/shop/services/ProductImageService';
import { ProductVariantService } from '$js/shop/services/ProductVariantService';

export default class ShopModule {
  private static instance: ShopModule | null = null;
  private _productImage: ProductImageService | null = null;
  private _productVariant: ProductVariantService | null = null;

  private bootModules = ['productImage'] as const;

  static getInstance(): ShopModule {
    ShopModule.instance ??= new ShopModule();
    return ShopModule.instance;
  }

  get productImage(): ProductImageService {
    this._productImage ??= new ProductImageService();
    return this._productImage;
  }

  get productVariant(): ProductVariantService {
    this._productVariant ??= new ProductVariantService();
    return this._productVariant;
  }

  boot(): void {
    type ModuleKey = (typeof this.bootModules)[number];

    this.bootModules.forEach((module: ModuleKey) => {
      return this[module];
    });
  }
}
